// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar_overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgb(0 0 0 / 32%);
  opacity: 0;
  pointer-events: none;
  z-index: 99;
  transition: opacity 0.3s ease;
}

/* When sidebar is showed */
.sidebar_overlay.active {
  opacity: 1;
  pointer-events: all;
}

.sidebar_content {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  width: 640px;
  background: #fff;
  z-index: 100;
  transition: transform 0.3s ease;
  transform: translateX(100%);
}

.sidebar_content.active {
  transform: translateX(0);
  box-shadow: -8px 0px 32px rgba(0, 0, 0, 0.16);
}

.sidebar_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 64px;
  border-bottom: 1px solid #ebebeb;
}

.sidebar_header h1 {
  color: #000000;
  font-size: 25px;
  font-weight: 700;
  margin-bottom: 0;
}

.sidebar_header .close_button {
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.sidebar_header .close_button img {
  width: 16px;
  height: 16px;
}

.sidebar_body .sidebar_body_section {
  position: relative;
  padding: 32.5px 64px 24px 64px;
}

.sidebar_body .sidebar_body_section .section_divider::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 64px;
  right: 0;
  height: 1px;
  background: #ebebeb;
}

.sidebar_body .sidebar_body_section_title h2 {
  color: #000000;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 0;
}

.sidebar_body .sidebar_body_item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
}

.sidebar_body .sidebar_body_item .item_label {
  color: #000000;
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
  margin-bottom: 0;
}

.sidebar_body .sidebar_body_item .item_description {
  color: #858585;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 0;
}

.sidebar_body .sidebar_body_item textarea {
  width: 512px;
  height: 160px;
  border: 1px solid #ebebeb;
  border-radius: 10px;
  margin-top: 24px;
  resize: none;
  padding: 8px 16px;
  color: #000000;
  font-size: 16px;
  font-weight: 400;
}

.sidebar_body .sidebar_body_item textarea:focus-visible {
  outline: none;
}

.sidebar_body_item .button-file {
  font-size: 14px;
  font-weight: 700;
  color: #4caf50;
  cursor: pointer;
}

.sidebar_body_item .file-preview-container {
  width: 100%;
  height: 46px;
  border: 1px solid #ebebeb;
  border-radius: 10px;
  overflow: hidden;
  padding: 0px 13px 0px 16px;
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sidebar_body_item .file-preview-container span {
  font-weight: 400;
  font-size: 14px;
  color: #858585;
}

.sidebar_body_item .file-preview-container .trash-button {
  background: none;
  border: none;
  padding: 0;
}

.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 32px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}

.slider .slider_contain {
  position: absolute;
  height: 18px;
  width: 18px;
  left: 6px;
  bottom: 7px;
  background-color: white;
  transition: 0.4s;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* .slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 6px;
  bottom: 7px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}
 */
input:checked + .slider {
  background-color: rgba(76, 175, 80, 1);
}

input:focus + .slider {
  box-shadow: 0 0 1px rgba(76, 175, 80, 1);
}

input:checked + .slider .slider_contain {
  transform: translateX(18px);
}

.slider_contain svg path {
  transition: fill 0.1s ease;
}

input:checked + .slider .slider_contain svg path {
  fill: #4caf50;
}

/* Rounded sliders */
.slider.round {
  border-radius: 16px;
}

.slider.round .slider_contain {
  border-radius: 50%;
}

.form-filter {
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.sidebar_actions {
  margin-top: 10px;
  width: 100%;
  padding: 0px 64px;
}

.sidebar_actions button {
  width: 252px;
  height: 48px;
  border-radius: 10px;
  background: #ebebeb;
  color: #ffffff;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
}

.sidebar_actions button:not(:disabled) {
  background: #4caf50;
}

.sidebar_actions button:first-child {
  background: none;
  font-size: 14px;
  font-weight: 700;
  color: #c2c2c2;
  text-align: start;
}

.sidebar_actions button:first-child:not(:disabled) {
  color: #4caf50;
}

/* The container */
.customInputContainer {
  /* display: block; */
  position: relative;
  /* padding-left: 35px;
  margin-bottom: 12px; */
  cursor: pointer;
  height: 24px;
  /* font-size: 22px; */
  -webkit-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.customInputContainer input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.radioCheckMark {
  position: absolute;
  top: 0;
  right: 0;
  height: 24px;
  width: 24px;
  /* background-color: #eee; */
  background-color: #ffffff;
  border-radius: 50%;
  outline: 3px solid #c9c5ca;
}

/* On mouse-over, add a grey background color */
/* .container:hover input~.checkmark {
  background-color: #ccc;
} */

/* When the radio button is checked, add a blue background */
.customInputContainer input:checked ~ .radioCheckMark {
  background-color: #ffff;
  outline: 3px solid #4caf50;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.radioCheckMark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.customInputContainer input:checked ~ .radioCheckMark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.customInputContainer .radioCheckMark:after {
  top: 25%;
  left: 25%;
  bottom: 25%;
  right: 25%;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: white;
  background: #4caf50;
}

.checkmark {
  position: absolute;
  top: 0;
  right: 0;
  height: 24px;
  width: 24px;
  /* background-color: #eee; */
  background-color: #ffffff;
  border-radius: 6px;
  outline: 2px solid #c9c5ca;
}

.customInputContainer input[type="checkbox"]:checked ~ .checkmark {
  background-color: #4caf50;
  outline-color: #4caf50;
  /* outline: 2px solid #4caf50; */
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.customInputContainer input[type="checkbox"]:checked ~ .checkmark:after {
  display: block;
}

.customInputContainer .checkmark:after {
  left: 9px;
  top: 5px;
  width: 8px;
  height: 12px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

.opacity {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgb(255 255 255 / 70%);
}
`, "",{"version":3,"sources":["webpack://./src/components/RightSidebar/RightSidebar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,4BAA4B;EAC5B,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;;;;;;;;EAWE;AACF;EACE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,kBAAkB;EAClB;wBACsB;EACtB,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,+CAA+C;AAC/C;;GAEG;;AAEH,4DAA4D;AAC5D;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,oEAAoE;AACpE;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,iDAAiD;AACjD;EACE,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,QAAQ;EACR,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EAGzB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;AACpC","sourcesContent":[".sidebar_overlay {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgb(0 0 0 / 32%);\n  opacity: 0;\n  pointer-events: none;\n  z-index: 99;\n  transition: opacity 0.3s ease;\n}\n\n/* When sidebar is showed */\n.sidebar_overlay.active {\n  opacity: 1;\n  pointer-events: all;\n}\n\n.sidebar_content {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: 640px;\n  background: #fff;\n  z-index: 100;\n  transition: transform 0.3s ease;\n  transform: translateX(100%);\n}\n\n.sidebar_content.active {\n  transform: translateX(0);\n  box-shadow: -8px 0px 32px rgba(0, 0, 0, 0.16);\n}\n\n.sidebar_header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px 64px;\n  border-bottom: 1px solid #ebebeb;\n}\n\n.sidebar_header h1 {\n  color: #000000;\n  font-size: 25px;\n  font-weight: 700;\n  margin-bottom: 0;\n}\n\n.sidebar_header .close_button {\n  background: none;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n}\n\n.sidebar_header .close_button img {\n  width: 16px;\n  height: 16px;\n}\n\n.sidebar_body .sidebar_body_section {\n  position: relative;\n  padding: 32.5px 64px 24px 64px;\n}\n\n.sidebar_body .sidebar_body_section .section_divider::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 64px;\n  right: 0;\n  height: 1px;\n  background: #ebebeb;\n}\n\n.sidebar_body .sidebar_body_section_title h2 {\n  color: #000000;\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 0;\n}\n\n.sidebar_body .sidebar_body_item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 24px;\n}\n\n.sidebar_body .sidebar_body_item .item_label {\n  color: #000000;\n  font-size: 14px;\n  line-height: 18px;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n\n.sidebar_body .sidebar_body_item .item_description {\n  color: #858585;\n  font-size: 14px;\n  font-weight: 400;\n  margin-bottom: 0;\n}\n\n.sidebar_body .sidebar_body_item textarea {\n  width: 512px;\n  height: 160px;\n  border: 1px solid #ebebeb;\n  border-radius: 10px;\n  margin-top: 24px;\n  resize: none;\n  padding: 8px 16px;\n  color: #000000;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.sidebar_body .sidebar_body_item textarea:focus-visible {\n  outline: none;\n}\n\n.sidebar_body_item .button-file {\n  font-size: 14px;\n  font-weight: 700;\n  color: #4caf50;\n  cursor: pointer;\n}\n\n.sidebar_body_item .file-preview-container {\n  width: 100%;\n  height: 46px;\n  border: 1px solid #ebebeb;\n  border-radius: 10px;\n  overflow: hidden;\n  padding: 0px 13px 0px 16px;\n  background: #fafafa;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.sidebar_body_item .file-preview-container span {\n  font-weight: 400;\n  font-size: 14px;\n  color: #858585;\n}\n\n.sidebar_body_item .file-preview-container .trash-button {\n  background: none;\n  border: none;\n  padding: 0;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 48px;\n  height: 32px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.slider .slider_contain {\n  position: absolute;\n  height: 18px;\n  width: 18px;\n  left: 6px;\n  bottom: 7px;\n  background-color: white;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* .slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 6px;\n  bottom: 7px;\n  background-color: white;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n */\ninput:checked + .slider {\n  background-color: rgba(76, 175, 80, 1);\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px rgba(76, 175, 80, 1);\n}\n\ninput:checked + .slider .slider_contain {\n  -webkit-transform: translateX(18px);\n  -ms-transform: translateX(18px);\n  transform: translateX(18px);\n}\n\n.slider_contain svg path {\n  transition: fill 0.1s ease;\n}\n\ninput:checked + .slider .slider_contain svg path {\n  fill: #4caf50;\n}\n\n/* Rounded sliders */\n.slider.round {\n  border-radius: 16px;\n}\n\n.slider.round .slider_contain {\n  border-radius: 50%;\n}\n\n.form-filter {\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n\n.sidebar_actions {\n  margin-top: 10px;\n  width: 100%;\n  padding: 0px 64px;\n}\n\n.sidebar_actions button {\n  width: 252px;\n  height: 48px;\n  border-radius: 10px;\n  background: #ebebeb;\n  color: #ffffff;\n  text-align: center;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.sidebar_actions button:not(:disabled) {\n  background: #4caf50;\n}\n\n.sidebar_actions button:first-child {\n  background: none;\n  font-size: 14px;\n  font-weight: 700;\n  color: #c2c2c2;\n  text-align: start;\n}\n\n.sidebar_actions button:first-child:not(:disabled) {\n  color: #4caf50;\n}\n\n/* The container */\n.customInputContainer {\n  /* display: block; */\n  position: relative;\n  /* padding-left: 35px;\n  margin-bottom: 12px; */\n  cursor: pointer;\n  height: 24px;\n  /* font-size: 22px; */\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n/* Hide the browser's default radio button */\n.customInputContainer input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n}\n\n/* Create a custom radio button */\n.radioCheckMark {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 24px;\n  width: 24px;\n  /* background-color: #eee; */\n  background-color: #ffffff;\n  border-radius: 50%;\n  outline: 3px solid #c9c5ca;\n}\n\n/* On mouse-over, add a grey background color */\n/* .container:hover input~.checkmark {\n  background-color: #ccc;\n} */\n\n/* When the radio button is checked, add a blue background */\n.customInputContainer input:checked ~ .radioCheckMark {\n  background-color: #ffff;\n  outline: 3px solid #4caf50;\n}\n\n/* Create the indicator (the dot/circle - hidden when not checked) */\n.radioCheckMark:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n/* Show the indicator (dot/circle) when checked */\n.customInputContainer input:checked ~ .radioCheckMark:after {\n  display: block;\n}\n\n/* Style the indicator (dot/circle) */\n.customInputContainer .radioCheckMark:after {\n  top: 25%;\n  left: 25%;\n  bottom: 25%;\n  right: 25%;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: white;\n  background: #4caf50;\n}\n\n.checkmark {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 24px;\n  width: 24px;\n  /* background-color: #eee; */\n  background-color: #ffffff;\n  border-radius: 6px;\n  outline: 2px solid #c9c5ca;\n}\n\n.customInputContainer input[type=\"checkbox\"]:checked ~ .checkmark {\n  background-color: #4caf50;\n  outline-color: #4caf50;\n  /* outline: 2px solid #4caf50; */\n}\n\n.checkmark:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n.customInputContainer input[type=\"checkbox\"]:checked ~ .checkmark:after {\n  display: block;\n}\n\n.customInputContainer .checkmark:after {\n  left: 9px;\n  top: 5px;\n  width: 8px;\n  height: 12px;\n  border: solid white;\n  border-width: 0 3px 3px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.opacity {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgb(255 255 255 / 70%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
